<div class="mini-grid">
    <img [src]="icon" [alt]="text"/>
    <p class="prevent-selection">{{ text }}</p>
</div>